import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import classNames from 'classnames';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'calc(100% /7)',
    borderRight: '1px solid',
    borderRightColor: theme.palette.grey[200],
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey[200],
  },
  projectedWeekColor: {
    backgroundColor: '#64E2BB2B',
  },
  dateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  dateButton: {
    minWidth: 32,
    height: 32,
    borderRadius: '50%',
    color: theme.palette.common.white,
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  availableColor: {
    backgroundColor: theme.palette.facet.accentGreen2,
  },
  someAvailabilityColor: {
    backgroundColor: theme.palette.facet.accentBlue11,
  },
  noAvailabilityColor: {
    backgroundColor: theme.palette.facet.red,
  },
  notInCurrentMonth: {
    display: 'none',
  },
  weekendDay: {
    color: theme.palette.facet.accentGray,
    fontWeight: 'bold',
  },
  dateItemText: {
    fontSize: theme.typography.body1.fontSize,
  },
  planningColor: {
    color: theme.palette.facet.accentBlue4,
  },
  proposalColor: {
    color: theme.palette.facet.accentBlue11,
  },
});

const SchedulerDay = ({
  classes,
  day,
  date,
  onDayNumberClick,
  currentMonth,
  items,
}) => {
  const inCurrentMonth = currentMonth.isSame(date, 'month');
  const [availabilityDayItem] = items;
  if (!availabilityDayItem) {
    return (
      <div
        className={classNames(classes.root)}
      >
        <div className={classNames(classes.dateContainer)} />
      </div>
    );
  }
  const { resource, projectedMeetingResource } = availabilityDayItem;
  const capacity = parseInt(resource.attr('capacity'), 10);
  const numberOfPlannings = resource.attr('planningMeetingCount');
  const numberOfProposals = resource.attr('proposalMeetingCount');
  const isWithinProjectedWeek = date.isSameOrAfter(projectedMeetingResource?.attr('start')) && date.isSameOrBefore(projectedMeetingResource?.attr('end'));

  const handleDayNumberClick = () => onDayNumberClick(date, resource);
  return (
    <div
      className={classNames(classes.root, {
        [classes.projectedWeekColor]: isWithinProjectedWeek,
      })}
    >
      <div
        className={classNames(classes.dateContainer, {
          [classes.notInCurrentMonth]: !inCurrentMonth,
        })}
        test="scheduler-month-day"
      >
        {
          <Button
            className={classNames(classes.dateButton, {
              [classes.availableColor]: capacity > 2,
              [classes.someAvailabilityColor]: capacity === 1 || capacity === 2,
              [classes.noAvailabilityColor]: capacity === 0,
            })}
            test={inCurrentMonth ? `scheduler-day-number${capacity > 2 ? '-available' : ''}` : undefined}
            onClick={handleDayNumberClick}
          >
            {day}
          </Button>
        }
          <>
            <div className={classNames(classes.dateItemText, classes.planningColor)}>
              {`${numberOfPlannings} Planning`}
            </div>
            <div className={classNames(classes.dateItemText, classes.proposalColor)}>
              {`${numberOfProposals} Proposal`}
            </div>
          </>
      </div>
    </div>
  );
};

SchedulerDay.defaultProps = {
  day: null,
  date: null,
  onDayNumberClick: null,
  items: [],
};

SchedulerDay.propTypes = {
  classes: PropTypes.object.isRequired,
  day: PropTypes.number,
  date: PropTypes.instanceOf(moment),
  onDayNumberClick: PropTypes.func,
  currentMonth: PropTypes.object.isRequired,
  items: PropTypes.array,
};

export default withStyles(styles)(SchedulerDay);
